<div class="min-h-screen bg-gradient-to-br">
  <app-loader [isLoading]="isLoading"></app-loader>

  <div class="p-6 bg-gray-50 min-h-screen">
    <!-- Titre modifié - même ligne avec le même style -->
    <div class="text-center mb-8">
      <app-page-title [titleKey]="'photos.pageTitle'"></app-page-title>
      <div class="text-4xl text-[#F48C06] mt-2">Album {{ albumName }}</div>
    </div>

    <!-- Photo grid -->
    <!-- Photo grid -->
    <!-- <div class="grid gap-6 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
  <div *ngFor="let photo of paginatedPhotos" 
       class="relative bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden transition-all duration-300 hover:shadow-lg cursor-pointer group">


    <div class="w-full h-80 overflow-hidden"> 
      <img [src]="photo.url"
           [alt]="'photos.albumPhoto' | translate"
           class="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
           loading="lazy">
      

      <div class="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
        <button (click)="downloadPhoto(photo.url)"
                class="px-4 py-2 bg-[#009A90] hover:bg-[#007A70] text-white rounded-full font-medium transition-colors duration-200 shadow-md">
          {{ 'photos.downloadPhoto' | translate }}
        </button>
      </div>
    </div>

   
    <div class="p-4">
      <h3 class="text-sm font-semibold text-gray-800 text-center mb-2">{{ 'photos.albumPhoto' | translate }}</h3>
      <p class="text-xs text-gray-500 text-center mb-3">2024-04-14</p>
      
  
      <button (click)="downloadPhoto(photo.url)"
              class="absolute bottom-3 right-3 w-8 h-8 bg-white rounded-full flex items-center justify-center shadow-md hover:bg-gray-50 transition-colors duration-200">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 15V9M12 9L8 6M12 9L16 6" stroke="#49BBBD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M21 15C21 17.2091 19.2091 19 17 19H7C4.79086 19 3 17.2091 3 15V12C3 9.79086 4.79086 8 7 8H17C19.2091 8 21 9.79086 21 12V15Z" stroke="#49BBBD" stroke-width="2"/>
        </svg>
      </button>
    </div>
  </div>
</div> -->

    <div class="diag"></div>

    <!-- Grid -->
    <section class="section">
      <div class="grid">
        <div *ngFor="let photo of paginatedPhotos">
          <!-- Card 1 -->
          <article class="card">
            <a class="frame" [href]="photo.url" target="_blank" rel="noopener">
              <img
                class="thumb"
                [src]="photo.url"
                [alt]="'photos.albumPhoto' | translate"
              />
            </a>
      <div class="meta">
              <!--
                Icone de téléchargement : déclenche la méthode `downloadFile(photo.url)`.
                Remarque : le téléchargement passe par le proxy `/api/download` pour contourner
                les restrictions CORS. Si le téléchargement échoue, le serveur peut renvoyer
                une page HTML (ex. page de login) au lieu d'une image — un message d'erreur
                lisible sera affiché dans ce cas.
              -->
            </div>
          </article>
        </div>
      </div>
    </section>
    <div class="flex justify-center items-center space-x-1 mt-8">
      <!-- Left Arrow Button -->
      <button
        (click)="previousPage()"
        [disabled]="currentPage === 1"
        class="w-10 h-10 flex items-center justify-center rounded-md bg-teal-50 border border-teal-200 hover:bg-teal-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-teal-50"
      >
        <svg
          class="w-5 h-5 text-teal-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M15 19l-7-7 7-7"
          ></path>
        </svg>
      </button>

      <!-- Page Numbers -->
      <ng-container *ngFor="let page of getVisiblePages()">
        <!-- Ellipsis -->
        <span
          *ngIf="page === '...'"
          class="w-10 h-10 flex items-center justify-center text-gray-500"
        >
          {{ "common.ellipsis" | translate }}
        </span>

        <!-- Page Number -->
        <button
          *ngIf="page !== '...'"
          (click)="goToPage(+page)"
          [class]="
            currentPage === +page
              ? 'w-10 h-10 flex items-center justify-center rounded-md bg-[#009688] text-white font-bold border border-[#009688]'
              : 'w-10 h-10 flex items-center justify-center rounded-md bg-white text-black border border-gray-200 hover:bg-gray-50 hover:border-gray-300 transition-colors'
          "
        >
          {{ page }}
        </button>
      </ng-container>

      <!-- Right Arrow Button -->
      <button
        (click)="nextPage()"
        [disabled]="currentPage === totalPages"
        class="w-10 h-10 flex items-center justify-center rounded-md bg-teal-50 border border-teal-200 hover:bg-teal-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-teal-50"
      >
        <svg
          class="w-5 h-5 text-teal-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 5l7 7-7 7"
          ></path>
        </svg>
      </button>
    </div>
  </div>
</div>
